import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Table from '../common/Table'
import Pagination from "react-js-pagination";
import Row from '../common/Row';
import MyPagination from "../common/Pagination";
import nl2br from 'react-newline-to-break';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class TableCash extends Table {
    constructor(props) {
        super(props);
        this.handleDownloadCsv = this.handleDownloadCsv.bind(this);
        this.handleUpdateStatus = this.handleUpdateStatus.bind(this);
    }
    
    /**
     * Handle download csv
     */
    handleDownloadCsv() {
        let searchConditions = this.props.searchConditions;
        let myURL = "/cashes/download?"+ $.param(searchConditions);
        location.href = myURL;
    }

    /**
     * Handle Update Status
     */
     handleUpdateStatus() {
        const updateId = [];
        $('.form-check-input:checked').each(function() {
            var id = $(this).val();
            updateId.push(id);
        });
        //alert(updateId);

        if(updateId.length > 0){
            if(!confirm('選択した申請の受取結果を更新しますか？')){
                return false;
            }else{
                const formData = new FormData();
                formData.append('update_id', updateId);
                const config = {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                }
                console.log(...formData.entries());

                axios.post('/api/cashes/update-receipt-status', formData, config).then(response => {
                    console.log("response");
                    console.log(response.data.success);

                    if (response.data.success) {
                        //toast.success(response.data.message);
                        location.reload();
                    } else {
                        toast.error(response.data.error);
                    }
                }).catch(error => {
                    toast.error(response.data.error);
                });
            }
        } else {
            toast.error('受取済みにする申請を選択して下さい。');
            //alert('受取済みにする申請を選択して下さい。');
            return false;
        }
    }
    
    render() {
        let pageShow = [], hasBtnSearch;
        if(!this.props.onSearch){
            this.state.dataShow = this.props.data.filter(this.searchColumn);
            hasBtnSearch = false;
        }else{
            this.state.dataShow = this.props.data;
            hasBtnSearch = true;
        }
        
        for (let i = (this.state.activePage - 1) * this.state.itemsCountPerPage; i < this.state.dataShow.length && i < this.state.activePage * this.state.itemsCountPerPage; i++) {
            pageShow.push(this.state.dataShow[i]);
        }
        return (
            <React.Fragment>
                <table className="table table-stripped table-hover mb-0">
                    <thead className="thead-light">
                        <tr>
                            {this.props.header.map((item, i) => 
                                <th onClick={item.isSort ? this.handleSortAllData : ()=>{}} className={item.isSort ? (this.state.columnSort == item.name ? 'isSort sorting' : 'isSort') : ''} data-sorttype={this.state.typeSort} column={item.name} key={i}>{item.title}
                                </th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {pageShow.map((dataRow, i) => {
                            if(this.props.hasOwnProperty('optionTR')){
                                return <Row color={this.props.optionTR.colors[dataRow[this.props.optionTR.conditionColumn]]} onEdit={this.handleEdit} onDelete={this.handleDelete} key ={i} data ={dataRow} header={this.props.header}/>;
                            }else{
                                return <Row color="" removeClick={this.props.removeClick} onEdit={this.handleEdit} onDelete={this.handleDelete} key ={i} data ={dataRow} header={this.props.header}/>;
                            }
                        })}
                    </tbody>
                </table>
                <div className="card-footer">
                    { (this.props.hasOwnProperty('myPagination') && this.props.hasOwnProperty('searchConditions') && this.props.myPagination == 1) ? (
                        <div className="row">
                            <div className="col-sm-2">
                                <div className="input-group-prepend">
                                    <button onClick={this.handleDownloadCsv} className="btn btn-sm bg-purple text-white" type="button">セブン銀行振込データ作成</button>
                                </div>
                            </div>
                            <div className="col-sm-1">
                                <div className="input-group-prepend">
                                    <button onClick={this.handleUpdateStatus} className="btn btn-sm bg-cyan text-white" type="button">受取結果を更新する</button>
                                </div>
                            </div>
                            <div className="col-sm-7">
                                <nav>
                                    <MyPagination
                                        onSearch={this.handleSearchByPage}
                                        searchConditions={this.props.searchConditions}
                                        lastPage={this.props.lastPage}
                                        currentPage={this.props.currentPage}
                                        />
                                </nav>
                            </div>
                            <div className="col-sm-2 text-right">
                                <strong>{this.props.total}件中{this.props.from}から{this.props.to}まで表示</strong>
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-sm-2">
                                <button type="button" className="btn bg-purple text-white">振込済にする</button>
                                <button type="button" className="btn bg-light cash-btn-retransfer">再振込する</button>
                            </div>
                            <div className="col-sm-8">
                                <nav>
                                    <Pagination
                                        innerClass="pagination justify-content-center mb-0"
                                        activePage={this.state.activePage}
                                        itemClass="page-item"
                                        activeClass="active"
                                        activeLinkClass="page-link"
                                        linkClass="page-link"
                                        itemsCountPerPage={this.state.itemsCountPerPage}
                                        totalItemsCount={this.state.dataShow.length}
                                        pageRangeDisplayed={5}
                                        onChange={this.handlePageChange}
                                        />
                                </nav>
                            </div>
                            <div className="col-sm-2">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text bg-white">表示</span>
                                    </div>
                                    <select className="form-control" onChange={this.handleCountPerPageChange} value={this.state.itemsCountPerPage}>
                                        <option>10</option>
                                        <option>20</option>
                                        <option>30</option>
                                        <option>50</option>
                                        <option>100</option>
                                    </select>
                                    <div className="input-group-append">
                                        <span className="input-group-text">件</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )
                    }
                </div>
                <ToastContainer />
            </React.Fragment>
        );
    }
}
